import { Directive, OnChanges, SimpleChanges, Input, ElementRef } from '@angular/core';
import { DialogRef } from './dialog-ref';

/**
 * Button that will close the current dialog.
 */
@Directive({
    selector: 'button[ihdDialogClose]',
    host: {
        '(click)': 'close(ihdDialogClose)',
        'type': 'button'
    }
})
export class DialogCloseComponent implements OnChanges {

    /** Dialog close input. */
    @Input('ihd-dialog-close') dialogResult: any;
    @Input('ihdDialogClose') ihdDialogClose: any;

    constructor(public dialogRef: DialogRef<any>,
                public elementRef: ElementRef) { }

    ngOnChanges(changes: SimpleChanges) {
        // $log.debug('dialog close', changes);
        // const proxiedChange = changes._matDialogClose || changes._mdDialogClose ||
        //   changes._matDialogCloseResult;
        //
        // if (proxiedChange) {
        //     this.dialogResult = proxiedChange.currentValue;
        // }
    }

    /**
     * Emit the close status via the onClose method into the hosting component (dialog component)
     * @param val
     */
    close(val) {
        if (this.dialogRef?.componentInstance?.onClose) {
            this.dialogRef.componentInstance.onClose();
        }
        this.dialogRef.close(val);
    }
}
